
(function ($) {

    /**
     * Initialize Vidyard players for background videos
     */
    function initVidyardPlayers() {
        // Vidyard API v4 typically auto-initializes, but we can manually trigger if needed
        if (typeof window.VidyardV4 !== 'undefined' && typeof window.VidyardV4.init === 'function') {
            window.VidyardV4.init();
        }
    }

    /**
     * Ensure Vidyard players in background video containers are properly centered
     * Only targets .video-container elements to avoid affecting other video players
     */
    function ensureVidyardCentering() {
        $('.video-container.vidyard-container').each(function () {
            const $container = $(this);
            const $player = $container.find('iframe, video, div[class*="vidyard"]').first();

            if ($player.length) {
                // Ensure proper centering
                $player.css({
                    'position': 'absolute',
                    'top': '50%',
                    'left': '50%',
                    'transform': 'translate(-50%, -50%)',
                    'width': '100vw',
                    'height': '56.25vw',
                    'min-height': '100%',
                    'min-width': '177.77vh',
                    'max-width': 'none'
                });
            }
        });
    }

    /**
     * Initialize background videos on page load
     */
    function initBackgroundVideos() {
        // Only check for Vidyard players within background video containers
        const $vidyardPlayers = $('.video-container .vidyard-player-embed');

        if ($vidyardPlayers.length > 0) {
            // Wait a bit for Vidyard script to load if it hasn't yet
            setTimeout(function () {
                initVidyardPlayers();
                // Check centering after a delay to allow Vidyard to render
                setTimeout(ensureVidyardCentering, 500);
            }, 100);

            // Also check periodically in case script loads later
            let checkCount = 0;
            const checkInterval = setInterval(function () {
                checkCount++;
                if (typeof window.VidyardV4 !== 'undefined') {
                    initVidyardPlayers();
                    setTimeout(ensureVidyardCentering, 500);
                    clearInterval(checkInterval);
                } else if (checkCount > 50) { // Stop checking after 5 seconds
                    clearInterval(checkInterval);
                }
            }, 100);

            // Check centering a few times after initialization to catch any delayed rendering
            let centeringCheckCount = 0;
            const centeringInterval = setInterval(function () {
                centeringCheckCount++;
                ensureVidyardCentering();
                if (centeringCheckCount >= 5) { // Check 5 times then stop
                    clearInterval(centeringInterval);
                }
            }, 500);
        }
    }

    // Initialize on page load
    $(document).ready(function () {
        initBackgroundVideos();
    });

    // Initialize when new background videos are added dynamically
    $(document).on('vidyard-ready', function () {
        initVidyardPlayers();
        setTimeout(ensureVidyardCentering, 500);
    });

    // Re-initialize when new content is loaded (for AJAX/dynamic content)
    $(document).on('background-videos-ready', function () {
        initBackgroundVideos();
    });

})(jQuery);

